import script from "./cert-manager.io.clusterissuer.vue?vue&type=script&setup=true&lang=ts"
export * from "./cert-manager.io.clusterissuer.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__